(function () {
  'use strict';

  const getTheme = () => window.LuxeraTheme || null;

  const initLoadedSection = (container) => {
    const section = container.closest('[data-product-recommendations-section]');
    if (!section) return;

    const theme = getTheme();
    theme?.initAnimations?.(section);
    theme?.refreshSliders?.(section);
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  };

  const loadRecommendations = (container) => {
    const url = container.dataset.url;
    if (!url || container.dataset.loaded === 'true') return;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('[data-product-recommendations]');

        if (!source || !source.innerHTML.trim()) {
          container.closest('[data-product-recommendations-section]')?.remove();
          return;
        }

        container.innerHTML = source.innerHTML;
        container.dataset.loaded = 'true';
        initLoadedSection(container);
      })
      .catch((err) => {
        console.error(err);
        container.closest('[data-product-recommendations-section]')?.remove();
      });
  };

  const initRecommendations = (root = document) => {
    root.querySelectorAll('[data-product-recommendations]').forEach((container) => {
      if (container.dataset.loaded === 'true') return;

      const hasProducts = container.querySelector(
        '.product-recommendations__grid, .product-recommendations__slider'
      );

      if (hasProducts) {
        container.dataset.loaded = 'true';
        initLoadedSection(container);
        return;
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries, obs) => {
            if (!entries[0].isIntersecting) return;
            obs.disconnect();
            loadRecommendations(container);
          },
          { rootMargin: '200px 0px' }
        );
        observer.observe(container);
      } else {
        loadRecommendations(container);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initRecommendations());

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.querySelector('[data-product-recommendations]')) {
      initRecommendations(section);
    }
  });
})();
